/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* ODADA v16 - button guide filters with locked vertical page position */
(function () {
  "use strict";

  if (window.location.pathname.replace(/\/$/, "") !== "/collections/odada") return;

  function nearestIndex(rail, items) {
    var index = 0;
    var smallest = Infinity;
    items.forEach(function (item, itemIndex) {
      var distance = Math.abs(item.offsetLeft - rail.scrollLeft);
      if (distance < smallest) {
        smallest = distance;
        index = itemIndex;
      }
    });
    return index;
  }

  function addSafeMouseDrag(rail, snapItems, onSettle) {
    var pointerIsDown = false;
    var dragging = false;
    var suppressClick = false;
    var pointerId = null;
    var startX = 0;
    var startScroll = 0;

    rail.addEventListener("dragstart", function (event) {
      event.preventDefault();
    });

    rail.addEventListener("pointerdown", function (event) {
      if (event.pointerType !== "mouse" || event.button !== 0) return;
      pointerIsDown = true;
      dragging = false;
      suppressClick = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = rail.scrollLeft;
    });

    rail.addEventListener("pointermove", function (event) {
      if (!pointerIsDown) return;
      var distance = event.clientX - startX;

      if (!dragging && Math.abs(distance) > 8) {
        dragging = true;
        suppressClick = true;
        rail.classList.add("is-dragging");
        if (rail.setPointerCapture) rail.setPointerCapture(pointerId);
      }

      if (!dragging) return;
      event.preventDefault();
      rail.scrollLeft = startScroll - distance;
    });

    function finish(event) {
      if (!pointerIsDown) return;
      pointerIsDown = false;

      if (dragging) {
        dragging = false;
        rail.classList.remove("is-dragging");
        if (rail.releasePointerCapture && rail.hasPointerCapture && rail.hasPointerCapture(pointerId)) {
          rail.releasePointerCapture(pointerId);
        }
        if (snapItems && snapItems.length) {
          var item = snapItems[nearestIndex(rail, snapItems)];
          if (item) rail.scrollTo({ left: item.offsetLeft, behavior: "smooth" });
        }
        if (onSettle) onSettle();
      }

      window.setTimeout(function () { suppressClick = false; }, 80);
    }

    rail.addEventListener("pointerup", finish);
    rail.addEventListener("pointercancel", finish);

    rail.addEventListener("click", function (event) {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }

  function startTeaCarousel() {
    var rail = document.querySelector(".odada-tea-rail");
    var previous = document.querySelector(".odada-tea-prev");
    var next = document.querySelector(".odada-tea-next");
    var cards = rail ? Array.prototype.slice.call(rail.querySelectorAll(".odada-tea-card")) : [];

    if (!rail || !previous || !next || !cards.length) return false;
    if (rail.dataset.odadaV16Ready === "true") return true;
    rail.dataset.odadaV16Ready = "true";

    function move(direction) {
      var index = nearestIndex(rail, cards);
      var target = Math.max(0, Math.min(cards.length - 1, index + direction));
      rail.scrollTo({ left: cards[target].offsetLeft, behavior: "smooth" });
    }

    function update() {
      var maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
      previous.disabled = rail.scrollLeft <= 3;
      next.disabled = maximum <= 3 || rail.scrollLeft >= maximum - 3;
    }

    previous.textContent = "<";
    next.textContent = ">";
    previous.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      move(-1);
    });
    next.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      move(1);
    });

    /* Explicit navigation guarantees that clicking anywhere on a card opens it. */
    cards.forEach(function (card) {
      card.addEventListener("click", function (event) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        window.location.assign(card.href);
      });
    });

    rail.addEventListener("keydown", function (event) {
      if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
        event.preventDefault();
        move(event.key === "ArrowLeft" ? -1 : 1);
      }
    });

    addSafeMouseDrag(rail, cards, update);
    rail.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    update();
    return true;
  }

  function startGuideCarousel() {
    var rail = document.querySelector(".odada-story-rail");
    var previous = document.querySelector(".odada-story-prev");
    var next = document.querySelector(".odada-story-next");
    var slides = rail ? Array.prototype.slice.call(rail.querySelectorAll(".odada-story-slide")) : [];
    var tabs = Array.prototype.slice.call(document.querySelectorAll(".odada-story-nav button"));

    if (!rail || !previous || !next || !slides.length) return false;
    if (rail.dataset.odadaV16Ready === "true") return true;
    rail.dataset.odadaV16Ready = "true";

    function keepTabVisible(tab) {
      var nav = tab ? tab.parentElement : null;
      if (!nav || nav.scrollWidth <= nav.clientWidth) return;

      var navRect = nav.getBoundingClientRect();
      var tabRect = tab.getBoundingClientRect();
      var amount = 0;

      if (tabRect.left < navRect.left + 6) {
        amount = tabRect.left - navRect.left - 10;
      } else if (tabRect.right > navRect.right - 6) {
        amount = tabRect.right - navRect.right + 10;
      }

      if (amount) nav.scrollBy({ left: amount, behavior: "smooth" });
    }

    function goTo(index) {
      var safeIndex = Math.max(0, Math.min(slides.length - 1, index));
      rail.scrollTo({ left: slides[safeIndex].offsetLeft, behavior: "smooth" });
    }

    function update() {
      var index = nearestIndex(rail, slides);
      previous.disabled = index === 0;
      next.disabled = index === slides.length - 1;
      tabs.forEach(function (tab, tabIndex) {
        var isActive = tabIndex === index;
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
        if (isActive) {
          tab.setAttribute("aria-current", "true");
          keepTabVisible(tab);
        } else {
          tab.removeAttribute("aria-current");
        }
      });
    }

    previous.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      goTo(nearestIndex(rail, slides) - 1);
    });
    next.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      goTo(nearestIndex(rail, slides) + 1);
    });
    tabs.forEach(function (tab, index) {
      tab.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        var pageX = window.pageXOffset;
        var pageY = window.pageYOffset;
        goTo(index);

        window.requestAnimationFrame(function () {
          if (Math.abs(window.pageYOffset - pageY) > 1) {
            window.scrollTo(pageX, pageY);
          }
        });
      });
    });

    rail.addEventListener("keydown", function (event) {
      if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
        event.preventDefault();
        goTo(nearestIndex(rail, slides) + (event.key === "ArrowLeft" ? -1 : 1));
      }
    });

    addSafeMouseDrag(rail, slides, update);
    rail.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    update();
    return true;
  }

  function initialise() {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      var teaReady = startTeaCarousel();
      var guidesReady = startGuideCarousel();
      if ((teaReady && guidesReady) || attempts >= 30) window.clearInterval(timer);
    }, 200);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialise, { once: true });
  } else {
    initialise();
  }
})();

/*
 * COCOMO AIDA ROUTINE ARROW FAILSAFE v6.5
 * AIDA only: handles Day/Night arrows from the live visible rail.
 * This delegated capture handler supports both button and link arrows
 * and does not change Every Routine, ODADA, or Tagshop behaviour.
 */
(function () {
  "use strict";

  if (window.cocomoAidaArrowFailsafeV65) return;
  window.cocomoAidaArrowFailsafeV65 = true;

  function liveStops(rail) {
    var maximum = Math.max(
      0,
      rail.scrollWidth - rail.clientWidth
    );
    var railRect = rail.getBoundingClientRect();
    var cards = Array.prototype.slice.call(
      rail.querySelectorAll(
        ".aida-card, [data-cocomo-carousel-card]"
      )
    );
    var stops = [];

    cards
      .map(function (card) {
        var cardRect = card.getBoundingClientRect();

        return Math.max(
          0,
          Math.min(
            rail.scrollLeft +
              cardRect.left -
              railRect.left,
            maximum
          )
        );
      })
      .sort(function (first, second) {
        return first - second;
      })
      .forEach(function (position) {
        var previous = stops[stops.length - 1];

        if (
          previous === undefined ||
          Math.abs(position - previous) > 4
        ) {
          stops.push(position);
        }
      });

    return stops;
  }

  function nearestIndex(rail, stops) {
    var selected = 0;
    var distance = Infinity;

    stops.forEach(function (position, index) {
      var candidate = Math.abs(
        position - rail.scrollLeft
      );

      if (candidate < distance) {
        distance = candidate;
        selected = index;
      }
    });

    return selected;
  }

  document.addEventListener(
    "click",
    function (event) {
      var target = event.target;
      var arrow =
        target && target.closest
          ? target.closest(
              ".av7 .aida-carousel .aida-arrow"
            )
          : null;

      if (!arrow) return;

      var carousel = arrow.closest(".aida-carousel");
      var rail = carousel
        ? carousel.querySelector(".aida-rail")
        : null;

      if (!rail) return;

      var stops = liveStops(rail);

      if (stops.length < 2) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var direction = arrow.classList.contains(
        "aida-prev"
      )
        ? -1
        : 1;
      var currentIndex = nearestIndex(rail, stops);
      var targetIndex = Math.max(
        0,
        Math.min(
          stops.length - 1,
          currentIndex + direction
        )
      );

      if (
        direction < 0 &&
        rail.scrollLeft <= 3
      ) {
        return;
      }

      var targetPosition = stops[targetIndex];
      var originalBehaviour =
        rail.style.scrollBehavior;

      /*
       * Use an immediate native position change so a just-revealed
       * tab cannot discard the request. Restore the normal smooth
       * behaviour immediately afterwards.
       */
      rail.style.scrollBehavior = "auto";
      rail.scrollLeft = targetPosition;

      window.requestAnimationFrame(function () {
        rail.style.scrollBehavior =
          originalBehaviour;
      });
    },
    true
  );
})();
/*
 * COCOMO UNIVERSAL COLLECTION CAROUSEL
 * VERSION 6.2 — CURRENT-FILE SAFE UPDATE
 * Install this block once at the bottom of Assets/custom.js.
 *
 * Preferred HTML attributes:
 *   data-cocomo-carousel
 *   data-cocomo-carousel-rail
 *   data-cocomo-carousel-card
 *   data-cocomo-carousel-prev
 *   data-cocomo-carousel-next
 *
 * Every Routine class fallbacks:
 *   .er12-carousel
 *   .er12-rail
 *   .er12-card / .er12-ugc-card
 *   .er12-arrow-prev
 *   .er12-arrow-next
 *
 * AIDA class fallbacks:
 *   .aida-carousel
 *   .aida-rail
 *   .aida-card
 *   .aida-prev
 *   .aida-next
 *
 * These narrowly scoped fallbacks survive Shopify's collection editor
 * when it removes custom data attributes. Existing data-based listings
 * and the separate ODADA v16 controller above remain unchanged.
 */
(function () {
  "use strict";

  function nearestStopIndex(rail, stops) {
    var selectedIndex = 0;
    var smallestDistance = Infinity;

    stops.forEach(function (position, index) {
      var distance = Math.abs(position - rail.scrollLeft);

      if (distance < smallestDistance) {
        smallestDistance = distance;
        selectedIndex = index;
      }
    });

    return selectedIndex;
  }

  function initialiseCarousel(carousel) {
    if (carousel.dataset.cocomoCarouselReady === "true") return;

    /*
     * Avoid adding a second set of listeners if the earlier July-only
     * custom.js block is still installed above this universal block.
     */
    if (carousel.dataset.cocomoJulyThemeReady === "true") return;

    var rail =
      carousel.querySelector("[data-cocomo-carousel-rail]") ||
      carousel.querySelector(".er12-rail") ||
      carousel.querySelector(".aida-rail") ||
      carousel.querySelector(
        ".cocomo-week1-calendar-grid, .cocomo-week1-grid"
      );

    var previous = carousel.querySelector(
      "[data-cocomo-carousel-prev], .er12-arrow-prev, .aida-prev"
    );

    var next = carousel.querySelector(
      "[data-cocomo-carousel-next], .er12-arrow-next, .aida-next"
    );

    var cards = [];

    if (rail) {
      cards = Array.prototype.slice.call(
        rail.querySelectorAll("[data-cocomo-carousel-card]")
      );

      /*
       * Every Routine compatibility when Shopify strips data attributes.
       */
      if (!cards.length) {
        cards = Array.prototype.slice.call(
          rail.querySelectorAll(
            ".er12-card, .er12-ugc-card"
          )
        );
      }

      /*
       * AIDA compatibility when Shopify strips data attributes.
       */
      if (!cards.length) {
        cards = Array.prototype.slice.call(
          rail.querySelectorAll(".aida-card")
        );
      }

      /*
       * Backward-compatible support for older Week 1 carousels.
       */
      if (!cards.length) {
        cards = Array.prototype.slice.call(
          rail.querySelectorAll(
            ".cocomo-week1-calendar-card, .cocomo-week1-card"
          )
        );
      }
    }

    if (!rail || !previous || !next || !cards.length) return;

    carousel.dataset.cocomoCarouselReady = "true";

    /*
     * Every Routine must keep native horizontal finger swiping while
     * allowing normal vertical page scrolling on mobile.
     */
    if (
      carousel.matches(
        ".er12-carousel, .aida-carousel"
      )
    ) {
      rail.style.setProperty(
        "touch-action",
        "auto",
        "important"
      );
      rail.style.setProperty(
        "-webkit-overflow-scrolling",
        "touch"
      );
    }

    var shouldLoop =
      carousel.hasAttribute("data-cocomo-carousel-loop") ||
      carousel.matches(
        ".cocomo-week1-calendar-carousel, .cocomo-week1-carousel"
      );

    var activeIndex = 0;
    var programmaticMove = false;
    var settleTimer = 0;
    var movementFallbackTimer = 0;

    function maximumScroll() {
      return Math.max(
        0,
        rail.scrollWidth - rail.clientWidth
      );
    }

    function scrollStops() {
      var maximum = maximumScroll();
      var railRect = rail.getBoundingClientRect();

      var positions = cards.map(function (card) {
        var cardRect = card.getBoundingClientRect();

        return Math.max(
          0,
          Math.min(
            rail.scrollLeft + cardRect.left - railRect.left,
            maximum
          )
        );
      });

      var stops = [];

      positions
        .sort(function (first, second) {
          return first - second;
        })
        .forEach(function (position) {
          var previousPosition = stops[stops.length - 1];

          if (
            previousPosition === undefined ||
            Math.abs(position - previousPosition) > 4
          ) {
            stops.push(position);
          }
        });

      if (!stops.length) {
        stops.push(0);
      }

      return stops;
    }

    function updateButtons() {
      var stops = scrollStops();

      if (!programmaticMove) {
        activeIndex = nearestStopIndex(rail, stops);
      }

      activeIndex = Math.max(
        0,
        Math.min(stops.length - 1, activeIndex)
      );

      previous.disabled =
        stops.length < 2 ||
        (!shouldLoop && activeIndex === 0);

      next.disabled =
        stops.length < 2 ||
        (!shouldLoop && activeIndex === stops.length - 1);
    }

    function moveOneCard(direction) {
      var stops = scrollStops();
      var targetIndex;
      var startingPosition;
      var targetPosition;

      if (stops.length < 2) {
        updateButtons();
        return;
      }

      /*
       * Always derive the current card from the live rail position.
       * This keeps arrows accurate when a carousel was initialised while
       * hidden inside a tab and is revealed later.
       */
      activeIndex = nearestStopIndex(rail, stops);

      if (shouldLoop) {
        targetIndex =
          (activeIndex + direction + stops.length) %
          stops.length;
      } else {
        targetIndex = Math.max(
          0,
          Math.min(
            stops.length - 1,
            activeIndex + direction
          )
        );
      }

      activeIndex = targetIndex;

      previous.disabled =
        stops.length < 2 ||
        (!shouldLoop && activeIndex === 0);

      next.disabled =
        stops.length < 2 ||
        (!shouldLoop && activeIndex === stops.length - 1);

      programmaticMove = true;

      window.clearTimeout(settleTimer);
      window.clearTimeout(movementFallbackTimer);

      startingPosition = rail.scrollLeft;
      targetPosition = stops[targetIndex];

      rail.scrollTo({
        left: targetPosition,
        behavior: "smooth"
      });

      /*
       * Some browsers can ignore the first smooth-scroll request when a
       * tabbed rail has just changed from hidden to visible. If the rail
       * has not started moving, retry once with a native instant scroll.
       */
      movementFallbackTimer = window.setTimeout(function () {
        if (
          Math.abs(targetPosition - startingPosition) > 2 &&
          Math.abs(rail.scrollLeft - startingPosition) < 2
        ) {
          rail.scrollTo({
            left: targetPosition,
            behavior: "auto"
          });
        }
      }, 120);

      settleTimer = window.setTimeout(function () {
        programmaticMove = false;
        updateButtons();
      }, 450);
    }

    previous.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      moveOneCard(-1);
    });

    next.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      moveOneCard(1);
    });

    rail.addEventListener("keydown", function (event) {
      if (
        event.key !== "ArrowLeft" &&
        event.key !== "ArrowRight"
      ) {
        return;
      }

      event.preventDefault();

      moveOneCard(
        event.key === "ArrowLeft" ? -1 : 1
      );
    });

    rail.addEventListener(
      "scroll",
      updateButtons,
      { passive: true }
    );

    window.addEventListener(
      "resize",
      updateButtons,
      { passive: true }
    );

    /*
     * Refresh the controls when a closed accordion is opened.
     * Shopify initially measures content inside a closed accordion
     * as zero width.
     */
    var containingDetails = carousel.closest("details");

    if (containingDetails) {
      containingDetails.addEventListener(
        "toggle",
        function () {
          if (!containingDetails.open) return;

          window.requestAnimationFrame(function () {
            updateButtons();
          });
        }
      );
    }

    /*
     * Refresh a carousel whenever its AIDA Day/Night panel becomes
     * visible. This is deliberately scoped to AIDA's routine tabs and
     * does not change any other collection's tabs or layout.
     */
    var aidaRoot = carousel.closest(".av7");

    if (aidaRoot) {
      aidaRoot
        .querySelectorAll(
          'input[name="aida-routine-tabs"]'
        )
        .forEach(function (tabInput) {
          tabInput.addEventListener(
            "change",
            function () {
              if (!tabInput.checked) return;

              window.requestAnimationFrame(function () {
                programmaticMove = false;
                activeIndex = nearestStopIndex(
                  rail,
                  scrollStops()
                );
                updateButtons();
              });
            }
          );
        });
    }

    updateButtons();
  }

  function initialiseAllCocomoCarousels() {
    document
      .querySelectorAll(
        "[data-cocomo-carousel], .er12-carousel, .aida-carousel"
      )
      .forEach(initialiseCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialiseAllCocomoCarousels,
      { once: true }
    );
  } else {
    initialiseAllCocomoCarousels();
  }

  document.addEventListener(
    "shopify:section:load",
    initialiseAllCocomoCarousels
  );
})();

/*
 * COCOMO TAGSHOP UGC LOADER
 * Rebuilds the Every Routine or AIDA wall attributes if Shopify strips them,
 * then loads Tagshop only on pages containing a social wall.
 */
(function () {
  "use strict";

  function loadCocomoTagshop() {
    var wall = document.querySelector(".tagshop-socialwall");

    if (!wall) return;

    if (wall.closest && wall.closest(".er12")) {
      wall.setAttribute("data-wall-id", "21846");
      wall.setAttribute("data-tags", "true");
      wall.setAttribute(
        "data-keywords",
        "#EveryRoutineTag"
      );
      wall.setAttribute("data-source", "website");

      if (
        wall.children.length === 1 &&
        wall.firstElementChild &&
        wall.firstElementChild.tagName === "BR"
      ) {
        wall.innerHTML = "";
      }
    }

    if (
      wall.closest &&
      wall.closest(".av7, .av6")
    ) {
      wall.setAttribute("data-wall-id", "21846");
      wall.setAttribute("data-tags", "true");
      wall.setAttribute(
        "data-keywords",
        "#AidaTag"
      );
      wall.setAttribute("data-source", "website");

      if (
        wall.children.length === 1 &&
        wall.firstElementChild &&
        wall.firstElementChild.tagName === "BR"
      ) {
        wall.innerHTML = "";
      }
    }

    var existingLoader = document.querySelector(
      'script[src*="widget.tagshop.ai/embed-lite.min.js"]'
    );

    if (existingLoader) return;

    var loader = document.createElement("script");
    loader.src = "https://widget.tagshop.ai/embed-lite.min.js";
    loader.async = true;
    loader.setAttribute("data-cocomo-tagshop-loader", "true");
    document.head.appendChild(loader);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      loadCocomoTagshop,
      { once: true }
    );
  } else {
    loadCocomoTagshop();
  }

  document.addEventListener(
    "shopify:section:load",
    loadCocomoTagshop
  );
})();

/* ==========================================================
   COCOMO MOBILE PRODUCT THUMBNAIL RAIL — AUTO-CENTRE V3
   Centres the image already selected or displayed by the store.
   It does not listen for clicks, select slides, change form values,
   submit carts, or interfere with native gallery swipe.
   ========================================================== */
(function () {
  "use strict";

  var mobileRailQuery = window.matchMedia(
    "(max-width: 1007px)"
  );
  var reducedMotionQuery = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  );

  function centreThumbnail(track, thumbnail) {
    if (!mobileRailQuery.matches || !track || !thumbnail) return;

    window.requestAnimationFrame(function () {
      var trackRect = track.getBoundingClientRect();
      var thumbRect = thumbnail.getBoundingClientRect();
      var targetLeft =
        track.scrollLeft +
        (thumbRect.left - trackRect.left) -
        (track.clientWidth - thumbRect.width) / 2;
      var maxLeft = Math.max(
        0,
        track.scrollWidth - track.clientWidth
      );
      var left = Math.max(0, Math.min(targetLeft, maxLeft));

      if (typeof track.scrollTo === "function") {
        track.scrollTo({
          left: left,
          behavior: reducedMotionQuery.matches
            ? "auto"
            : "smooth"
        });
      } else {
        track.scrollLeft = left;
      }
    });
  }

  function clearDisplayedMediaMarker(navigation) {
    navigation.classList.remove(
      "has-cocomo-displayed-media"
    );

    navigation
      .querySelectorAll(".is-cocomo-displayed-media")
      .forEach(function (thumbnail) {
        thumbnail.classList.remove(
          "is-cocomo-displayed-media"
        );
      });
  }

  function syncDisplayedMedia(
    navigation,
    track,
    mediaId
  ) {
    clearDisplayedMediaMarker(navigation);

    var match = null;

    if (mediaId) {
      navigation
        .querySelectorAll(".Product__SlideshowNavImage")
        .forEach(function (thumbnail) {
          if (
            String(thumbnail.getAttribute("data-media-id")) ===
            String(mediaId)
          ) {
            match = thumbnail;
          }
        });
    }

    if (!match) {
      match = navigation.querySelector(
        ".Product__SlideshowNavImage.is-selected"
      );
    }

    if (!match) return;

    if (
      mediaId &&
      String(match.getAttribute("data-media-id")) ===
        String(mediaId) &&
      !match.classList.contains("is-selected")
    ) {
      navigation.classList.add(
        "has-cocomo-displayed-media"
      );
      match.classList.add(
        "is-cocomo-displayed-media"
      );
    }

    centreThumbnail(track, match);
  }

  function syncCurrentDisplayedMedia(
    navigation,
    track,
    productSection
  ) {
    window.requestAnimationFrame(function () {
      var selectedSlide = productSection
        ? productSection.querySelector(
            ".Product__SlideItem.is-selected"
          )
        : null;
      var displayedMediaId = selectedSlide
        ? selectedSlide.getAttribute(
            "data-cocomo-displayed-media-id"
          )
        : null;

      syncDisplayedMedia(
        navigation,
        track,
        displayedMediaId
      );
    });
  }

  function initialiseMobileThumbnailRail(root) {
    var scope = root && root.querySelectorAll
      ? root
      : document;

    scope
      .querySelectorAll(
        ".template-product " +
        ".Product__SlideshowNav--thumbnails"
      )
      .forEach(function (navigation) {
        if (
          navigation.getAttribute(
            "data-cocomo-mobile-thumb-rail"
          ) === "ready"
        ) {
          return;
        }

        var track = navigation.querySelector(
          ".Product__SlideshowNavScroller"
        );
        if (!track) return;

        var productSection = navigation.closest(
          '[data-section-type="product"]'
        );

        navigation.setAttribute(
          "data-cocomo-mobile-thumb-rail",
          "ready"
        );

        var thumbnailObserver = new MutationObserver(
          function (changes) {
            changes.forEach(function (change) {
              var thumbnail = change.target;

              if (
                change.type === "attributes" &&
                thumbnail.classList.contains(
                  "Product__SlideshowNavImage"
                ) &&
                thumbnail.classList.contains("is-selected")
              ) {
                syncCurrentDisplayedMedia(
                  navigation,
                  track,
                  productSection
                );
              }
            });
          }
        );

        navigation
          .querySelectorAll(".Product__SlideshowNavImage")
          .forEach(function (thumbnail) {
            thumbnailObserver.observe(thumbnail, {
              attributes: true,
              attributeFilter: ["class"]
            });
          });

        if (productSection) {
          var displayedMediaObserver = new MutationObserver(
            function () {
              syncCurrentDisplayedMedia(
                navigation,
                track,
                productSection
              );
            }
          );

          displayedMediaObserver.observe(productSection, {
            attributes: true,
            attributeFilter: [
              "data-cocomo-displayed-media-id"
            ],
            subtree: true
          });
        }
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        initialiseMobileThumbnailRail(document);
      },
      { once: true }
    );
  } else {
    initialiseMobileThumbnailRail(document);
  }

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initialiseMobileThumbnailRail(event.target);
    }
  );
})();

(function () {
  "use strict";
  if (window.cocomoHeaderDrawerPlacementReady) return;
  window.cocomoHeaderDrawerPlacementReady = true;

  var announcement = null;
  var resizeObserver = null;
  var visibilityObserver = null;

  function syncAnnouncementHeight() {
    var height = announcement && !announcement.hidden
      ? announcement.getBoundingClientRect().height
      : 0;
    document.documentElement.style.setProperty(
      "--cocomo-sticky-announcement-height", height + "px"
    );
  }

  function placeSidebarAccount() {
    var drawer = document.getElementById("sidebar-menu");
    if (!drawer) return;
    var container = drawer.querySelector(".Drawer__Container");
    var account = drawer.querySelector(".cb-drawer-bottom");
    if (!container || !account) return;
    var navigation = container.querySelector(".SidebarMenu__Nav--primary") ||
      container.querySelector("[data-cmm-menu]");
    if (navigation && navigation.nextElementSibling !== account) {
      navigation.after(account);
    }
  }

  function initialisePlacement() {
    placeSidebarAccount();
    var current = document.getElementById("c99-announcement-bar");
    if (current !== announcement) {
      if (resizeObserver) resizeObserver.disconnect();
      if (visibilityObserver) visibilityObserver.disconnect();
      announcement = current;
      if (announcement) {
        if ("ResizeObserver" in window) {
          resizeObserver = new ResizeObserver(syncAnnouncementHeight);
          resizeObserver.observe(announcement);
        }
        visibilityObserver = new MutationObserver(syncAnnouncementHeight);
        visibilityObserver.observe(announcement, {
          attributes: true, attributeFilter: ["hidden"]
        });
      }
    }
    syncAnnouncementHeight();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialisePlacement, {once: true});
  } else {
    initialisePlacement();
  }
  document.addEventListener("shopify:section:load", initialisePlacement);
  document.addEventListener("shopify:section:unload", function (event) {
    if (announcement && event.target.contains(announcement)) {
      if (resizeObserver) resizeObserver.disconnect();
      if (visibilityObserver) visibilityObserver.disconnect();
      announcement = null;
      syncAnnouncementHeight();
    }
  });
  window.addEventListener("resize", syncAnnouncementHeight, {passive: true});
  window.addEventListener("pageshow", initialisePlacement);
})();
